/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export enum PspPermission {
  ADMIN_FINTECHS_GET = 'admin.fintechs.get',
  ADMIN_FINTECHS_LIST_GET = 'admin.fintechs.list.get',
  IAM_CLIENT_CREDENTIALS_POST = 'iam.client_credentials.post',
  IAM_CLIENT_CREDENTIALS_DELETE = 'iam.client_credentials.delete',
  WEBHOOKS_PAAS_PATCH = 'paas.core.webhooks.patch',
  WEBHOOKS_PAAS_DELETE = 'paas.core.webhooks.delete',
  WEBHOOKS_SPI_PATCH = 'spi.core.webhooks.patch',
  WEBHOOKS_SPI_DELETE = 'spi.core.webhooks.delete',
  WEBHOOKS_SPI_INTEGRATOR = 'spi.core.integrator.identity.post',
}

export const getAuthorizedScopes = (permission: Array<string>) => {
  return permission.reduce((allScopes, currentScope, index, permission) => {
    if (index === permission.length - 1) {
      allScopes.push(`${permission.join('.')}`);
      allScopes.push('*');
    } else {
      allScopes.push(`${permission.slice(0, index + 1).join('.')}.*`);
    }
    return allScopes;
  }, [] as Array<string>);
};
